export const MAX_VIEW_WIDTH = 499;
